import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { useSelector } from 'react-redux';
import { Roles } from 'src/enums';
import { RootState } from 'src/redux/rootReducer';
import { useGetClientInfoQuery } from 'src/redux/services/clients';
import { CustomMuiIcon } from '../custom/CustomMuiIcon';
import { CustomTypography } from '../custom/CustomTypography';
import { NewSettings } from '../settings/NewSettings';
import { useParams } from 'react-router-dom';

const OrgSettingsComponent = () => {
  const { appId = '' } = useParams<{ appId: string }>();
  const { data: clientInfo, isLoading } = useGetClientInfoQuery({ id: appId });
  const roleInApp = useSelector(({ user }: RootState) => user.roleInApp);

  if (isLoading || clientInfo === undefined) {
    return <CustomTypography>Загрузка...</CustomTypography>;
  }

  if (roleInApp === Roles.ADMIN) {
    return <NewSettings selectedClient={clientInfo} />;
  }

  return (
    <div className="wrapper">
      <div className="content">
        <div>
          <CustomTypography className="text-16">Не достаточно прав доступа</CustomTypography>
          <CustomTypography className="text-14" color="grey">
            Для просмотра ЛК сервиса
          </CustomTypography>
          <CustomMuiIcon Icon={BlockOutlinedIcon} style={{ width: 40, height: 40 }} color="grey" />
        </div>
      </div>
    </div>
  );
};

export const OrgSettings = OrgSettingsComponent;
